import React from 'react';
import './style.css';

import CommonRow from '@elements/ContainerRowItem/CommonRow';

type VariantFullPurple = {
  id?: string;
  ridx: number;
  cells: Array<{
    cid: string;
  }>;
};

const VariantFullPurple = ({ cells, ridx, id }: VariantFullPurpleProps): JSX.Element => (
  <CommonRow cells={cells} className="variant-full-purple" id={id} ridx={ridx} />
);

export default VariantFullPurple;
